module.exports = __webpack_public_path__ + "static/media/Picker_niveau2_elN0_2_732410671.3b0c49c6.png";